export enum BulkBasicBetterBest {
  BASIC = 'Basic',
  BETTER = 'Better',
  BEST = 'Best'
}
